import { AppDispatch } from "../../../../core/store/store";
import {
	onConnectSocket,
	onDisconnectSocketMatch,
	onGetReportSubject,
	onNotificationLike,
} from "../../../match/presentation/store/MatchThunk";
import {
	onConnectSocketChat,
	onDisconnectSocketChat,
	onGetChats,
	onListenNewMessages,
	onListenTempMessages,
	onListenUpdatedChatStatus,
	onListenUpdatedMessages,
} from "../../../chat/presentation/store/ChatThunk";
import {
	onConnectPartnerSocket,
	onDisconnectPartnerSocket,
	onGetPendingPartner,
	onListenNotification,
	onListenNotificationResponse,
} from "../../../settings/presentation/store/PartnerThunk";
import {
	onGetCategories,
	onGetProfileConfig,
	onGetReferralCode,
	onGetUser,
	onListenPartnerInvitation,
} from "../store/OnboardingThunk";
import {
	onConnectSocketAdmin,
	onDisconnectSocketAdmin,
	onGetVideos,
	onNotificationAlert,
} from "../../../admin/presentation/store/AdminThunk";
import {
	onConnectSockeNotification,
	onDisconnectSocketNotification,
	onPurchaseMessageNotification,
} from "../../../notification/presentation/store/NotificationThunk";
import {
	onGetSubscriptionAll,
	onGetSubscriptionByUser,
} from "../../../subscriptions/presentation/store/SubscriptionsThunk";

export const loadSignedInBootstrapData = (dispatch: AppDispatch) => {
	dispatch(onGetProfileConfig());
	dispatch(onGetReportSubject());
	dispatch(onGetReferralCode());
	dispatch(onGetSubscriptionAll());
	dispatch(onGetVideos());
	dispatch(onGetPendingPartner());
	dispatch(onGetSubscriptionByUser());
	dispatch(onGetChats());
};

export const loadInitialAppData = (dispatch: AppDispatch) => {
	dispatch(onGetCategories());
	dispatch(onGetUser());
};

export const refreshVisibleRealtimeData = (dispatch: AppDispatch) => {
	dispatch(onGetProfileConfig());
	dispatch(onGetPendingPartner());
	dispatch(onGetSubscriptionByUser());
	dispatch(onGetChats());
};

export const startRealtimeSession = async (dispatch: AppDispatch) => {
	dispatch(onConnectSocket());
	dispatch(onNotificationLike());
	dispatch(onConnectSocketChat());
	dispatch(onListenNewMessages());
	dispatch(onListenUpdatedMessages());
	dispatch(onListenUpdatedChatStatus());
	dispatch(onListenTempMessages());
	dispatch(onConnectSocketAdmin());
	dispatch(onNotificationAlert());
	dispatch(onConnectSockeNotification());
	dispatch(onPurchaseMessageNotification());

	await dispatch(onConnectPartnerSocket());
	dispatch(onListenNotification());
	dispatch(onListenNotificationResponse());
	dispatch(onListenPartnerInvitation());
};

export const stopRealtimeSession = (dispatch: AppDispatch) => {
	dispatch(onDisconnectSocketMatch());
	dispatch(onDisconnectSocketChat());
	dispatch(onDisconnectPartnerSocket());
	dispatch(onDisconnectSocketAdmin());
	dispatch(onDisconnectSocketNotification());
};
